import { useEffect } from "react"
import useRedirectPage from "./useRedirectPage"
import { useParams } from "react-router-dom"

const RedirectPage = () => {
    const {
        checkTokenCalibrator
    } = useRedirectPage()
    const params = useParams()

    useEffect(() => {
        if (params.token) {
            checkTokenCalibrator(params.token, params.project_id, params.bu_performance, params.prev_calibrator, params.prev_calibrator_name)
        }
    }, [])

    return(
        <div className="container-fluid" style={{ height: "100vh" }}>
            <h1>Redirect Page</h1>
        </div>
    )
}

export default RedirectPage